import React from 'react';
import { v2LandingContactChannels } from '../../data/v2LandingCopy';

const FinalCTAV2 = ({ copy }) => {
  if (!copy) return null;
  return (
    <section className="iv2-final-cta" id="contact" data-testid="iv2-final-cta">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline">{copy.headline}</h2>
        <p className="iv2-final-cta-body">{copy.body}</p>
        <ul className="iv2-final-contacts">
          {copy.contacts.map((c) => {
            const chan = v2LandingContactChannels[c.id];
            if (!chan) return null;
            return (
              <li key={c.id} className="iv2-final-contact" data-testid={`iv2-final-cta-${c.id}`}>
                <span className="iv2-final-contact-label">{c.label}:</span>{' '}
                <a href={chan.href} className="iv2-final-contact-link">{chan.value}</a>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
export default FinalCTAV2;
